import { render, staticRenderFns } from "./ColoredLetterSquare.vue?vue&type=template&id=682ea8f8&"
import script from "./ColoredLetterSquare.vue?vue&type=script&lang=js&"
export * from "./ColoredLetterSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports